// walkaround for error: ReferenceError: global is not defined at node_modules/react-super-responsive-table/dist/components/Table.js
// appeared when removed reactjs-dropdown-component import
window.global ||= window;
